<template>
<div>
<notifications group="success" position="top center" width="80%"/>
<Loader v-if="loading != 0"></Loader>
<div class="limiter">
	<div class="container-login100" :style="'background-image: url(images/bg-01.jpg?v='+v+');'">
		<div class="wrap-login100">
			<form class="login100-form validate-form" >
				<span class="login100-form-logo">
					<!-- <i class="zmdi zmdi-landscape"></i> -->
					<img :src="'images/talk-bubble-color.png?v='+v" style="border-radius: 10px;width: 75px;" />
				</span>
				<span class="login100-form-title p-b-34 p-t-27">{{ $t('App Name') }}</span>
				<div :class="'wrap-input100 validate-input ' + cls_invalid_email" :data-validate = "$t(showMessage('login_email'))"> 
					<input class="input100" type="text" name="email" :placeholder="$t('E-Mail Address')" v-model="login_email" @keyup="pressKeyLogin">
					<span class="focus-input100" data-placeholder=""></span>
				</div>
				<div :class="'wrap-input100 validate-input ' + cls_invalid_password" :data-validate="$t(showMessage('login_password'))">
					<input class="input100" type="password" name="pass" :placeholder="$t('Password')" v-model="login_password" @keyup="pressKeyLogin">
					<span class="focus-input100" data-placeholder=""></span>
				</div>
				<div class="contact100-form-checkbox">
					<input class="input-checkbox100" id="ckb1" type="checkbox" name="remember-me" v-model="login_remember">
					<label class="label-checkbox100" for="ckb1">
						{{ $t('Remember Me') }}
					</label>
				</div>
				<div class="container-login100-form-btn">
					<button type="button" class="login100-form-btn" @click="submitLogin">
						{{ $t('Login') }}
					</button>
				</div>
				<div class="text-center p-t-90">
					<a class="txt1" href="#">
						{{ $t('Forgot Your Password?') }}
					</a>
				</div>
			</form>
		</div>
	</div>
</div>
</div>
</template>

<script>
	
    export default {
        computed: {
			v(){
				return window.ver;
			},
            loading() {
                return this.$store.state.services.loading;
            },
			cls_invalid_email() {
				if(this.showMessage('login_email')) return 'alert-validate';
				return '';
			},
			cls_invalid_password() {
				if(this.showMessage('login_password')) return 'alert-validate';
				return '';
			}
        },
		data() {
			return {
				verrors: [],
				login_email: '',
				login_password: '',
				login_remember: false,
				interval: null
			}
		},
        mounted() {
            // console.log('App mounted.');
			window.onload = function() {
				if (typeof(Storage) !== "undefined") {
					var dataThemeconfig = localStorage.getItem('themeconfig');
					var themeconfig = JSON.parse(dataThemeconfig);
					if(themeconfig){
						const style = document.createElement('style');
						style.innerHTML = `
							  .wrap-login100 {
								  background: -webkit-linear-gradient(top, ${themeconfig.login_bg_color1}, ${themeconfig.login_bg_color2});
								  background: -o-linear-gradient(top, ${themeconfig.login_bg_color1}, ${themeconfig.login_bg_color2});
								  background: -moz-linear-gradient(top, ${themeconfig.login_bg_color1}, ${themeconfig.login_bg_color2});
								  background: linear-gradient(top, ${themeconfig.login_bg_color1}, ${themeconfig.login_bg_color2});
								}
								.login100-form-btn {
								  background: -webkit-linear-gradient(bottom, ${themeconfig.login_bg_color1}, ${themeconfig.login_bg_color2});
								  background: -o-linear-gradient(bottom, ${themeconfig.login_bg_color1}, ${themeconfig.login_bg_color2});
								  background: -moz-linear-gradient(bottom, ${themeconfig.login_bg_color1}, ${themeconfig.login_bg_color2});
								  background: linear-gradient(bottom, ${themeconfig.login_bg_color1}, ${themeconfig.login_bg_color2});
								}
								.login100-form-logo{background-color: ${themeconfig.login_bg_color2}}
							`;
						document.head.appendChild(style);
					}else{
						const style = document.createElement('style');
						style.innerHTML = `
							  .wrap-login100 {
								  background: -webkit-linear-gradient(top, #459183, #00b29a);
								  background: -o-linear-gradient(top, #459183, #00b29a);
								  background: -moz-linear-gradient(top, #459183, #00b29a);
								  background: linear-gradient(top, #459183, #00b29a);
								}
								.login100-form-btn {
								  background: -webkit-linear-gradient(bottom, #459183, #00b29a);
								  background: -o-linear-gradient(bottom, #459183, #00b29a);
								  background: -moz-linear-gradient(bottom, #459183, #00b29a);
								  background: linear-gradient(bottom, #459183, #00b29a);
								}
								.login100-form-logo{background-color: #00b29a}
							`;
						document.head.appendChild(style);
					}
				}
			}
			
			let $dis = this;
			if(!this.interval){
				this.interval = setInterval(function(){ 
					$dis.loadAppTemp();
				}, window.resetalltime3, $dis);
			}
			this.loadAppTemp();
        },
		methods: {
			loadAppTemp(){
				let form = new FormData();
				// form.append('time', moment());
				axios.post('/apptimetamps', form).then(response => {
                }).catch(error => {
                    // this.$store.commit('setError', 'An error has occured, please contact support.');
                });
			},
			pressKeyLogin: function(e){
				if (e.keyCode === 13) {
					this.submitLogin();	
				} 
			},
			showMessage(field) {
				var error = '';
				if (this.verrors.hasOwnProperty(field)) {
					var msgs =  this.verrors[field];
					if (Array.isArray(msgs)) {
						error = msgs[0];
					}else {
						error =  msgs;
					}
			  };
			  return error;
			},
			submitLogin() {
				this.$store.commit('serviceLoading');
				let form = new FormData();
				form.append('login_email', this.login_email);
                form.append('login_password', this.login_password); 
                form.append('login_remember', this.login_remember); 
                axios.post('ajaxLogin', form, {
                    headers: {
                      'Content-Type': 'multipart/form-data',
					  'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                }).then(response => {
                    this.$store.commit('serviceFinished');

					if(response.data.error){
						this.verrors = response.data.message;
					}else{
						//login successfully
						//alert(response.data.message);
						this.$notify({
						  group: 'success',
						  title: response.data.title,
						  text: response.data.message,
						  duration: 10000,
						  speed: 1000
						});
						location.href=response.data.url;
					}
                }).catch(error => {
                    this.$store.commit('serviceFinished');
					console.log(error);
                });
			}
		}
		
    }
</script>
<style>

</style>